import { MagentoPatternsFilters } from '..';

const MAGENTO_PATTERNS_CATEGORY_ID = 3;

export const ensurePatternsCategoryFilter = (
    filters?: MagentoPatternsFilters,
): MagentoPatternsFilters => {
    if (!!filters?.category_id) {
        /**
         * If there already is a category_id filter,
         * we don't change anything
         */
        return filters;
    }
    /**
     * Else, we add the base magento patterns category id in filters,
     * to ensure only patterns are returned
     */
    return {
        ...filters,
        category_id: {
            in: [MAGENTO_PATTERNS_CATEGORY_ID],
        },
    };
};
